import { ActivatedRouteSnapshot } from '@angular/router';
import { Type } from '@angular/core';

export function findRouteForComponent(
  route: ActivatedRouteSnapshot | null | undefined,
  component: Type<unknown>,
): ActivatedRouteSnapshot | undefined {
  while (route && route.component !== component) {
    // TODO: Is the firstChild always the primary outlet?
    route = route.firstChild;
  }
  return route ?? undefined;
}

export function findRouteParam(
  route: ActivatedRouteSnapshot | null | undefined,
  param: string,
): string | undefined {
  while (route) {
    const value = route.params[param];
    if (value) {
      return value;
    }
    route = route.firstChild;
  }
  return undefined;
}
